import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client/react";

import rethrowIfNotAborted from "apollo/rethrowIfNotAborted";

import { GET_GITHUB_ENTERPRISE_WEBHOOKS_ENDPOINT } from "./gql";

const useGetGitHunEnterpriseWebhooksEndpoint = () => {
  const [githubEnterpriseWebhooksEndpoint, { data }] = useLazyQuery(
    GET_GITHUB_ENTERPRISE_WEBHOOKS_ENDPOINT
  );

  const generateWebhookUrl = useCallback(
    (id?: string) => {
      githubEnterpriseWebhooksEndpoint({
        ...(id && {
          variables: {
            id,
          },
        }),
      }).catch(rethrowIfNotAborted);
    },
    [githubEnterpriseWebhooksEndpoint]
  );

  return {
    webhookUrl: data?.githubEnterpriseWebhooksEndpoint,
    generateWebhookUrl,
  };
};

export default useGetGitHunEnterpriseWebhooksEndpoint;
